<template>
    <div class="item" @click="onPressDetail">
        <p class="title">{{item.name}}</p>
        <p class="text">{{item.overview}}</p>
        <p class="time">发布：{{item.create_time}}</p>
    </div>
</template>
<script>
export default {
    name: "salonItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        // 路由跳转
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
        // 跳转详情
        onPressDetail() {
            console.log('item', this.item)
            // window.location.href = 'https://wap.ys141319.com/h5/salon/detail?id=517'
        }
    },
    created() {
        console.log('this', this)
    },
};
</script>
<style lang="less" scoped>
.item {
    background: #fff;
    padding: 1rem 1rem;
    margin: 1rem 1.5rem;
    border-radius: .5rem;

    .title {
        color: #333;
        font-size: 1.5rem;
    }

    .text {
        color: #555;
        margin: .5rem 0;
        line-height: 1.8;
        font-size: 1.2rem;
    }

    .time {
        color: #666;
        font-size: 1.2rem;
    }
}
</style>